module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/citi@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/citi@3x.png
// module id = 1166
// module chunks = 0